import { useContext, useEffect, useState } from "react";

import PanelContext from "../context/PanelContext";
import DashboardContext from "../context/DashboardContext";

import Box from "@mui/material/Box";
import CategoriesRankingGraphicCard from "../components/panel/CategoriesRankingGraphicCard";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import DiscountRanking from "../components/panel/DiscountRankingRow";
import GeneratedEconomyCard from "../components/panel/GeneratedEconomyCard";
import MostUsedRow from "../components/saude/MostUsedRow";
import NumberOfUsesCard from "../components/panel/NumberOfUsesCard";
import RecentlyUsedRow from "../components/panel/RecentlyUsedRow";
import Stack from "@mui/material/Stack";
import TitleAndFilter from "../components/panel/TitleAndFilter";
import Typography from "@mui/material/Typography";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
  fetchResume,
  fetchAllEstablishments,
  fetchReport,
  activeInativeMembers,
  numberDash,
  getPanelData,
} from "../services";

import { cpfFormatter, cpfValidator } from "../utils";
import FavoritesRow from "../components/panel/FavoritesRow";
import { Skeleton } from "@mui/material";
import NumberOfMoreDataSaude from "../components/saude/NumberOfMoreDataSaude";
import BoxOfDataNumbers from "../components/saude/BoxOfDataNumbers";

export default function Saude() {
  // ----- ESTADOS DA APLICAÇÃO

  const [isLoading, setIsLoading] = useState(true);
  const [cpfError, setCpfError] = useState(false);
  const [allQueries, setAllQueries] = useState(0);
  const [filterState, setFilterState] = useState(false);
  const [dataPainel, setDataPainel] = useState({});

  // IMPORTAÇÕES DO CONTEXTO

  const {
    panelTitle,
    setPanelTitle,
    clientId,
    clientUser,
    clientLogo,
    clientPassword,
    token, typeClient
  } = useContext(DashboardContext);

  // CONTEXTO DO PAINEL

  const context = {};
  useEffect(() => {
    setIsLoading(true);
    let params = {  }
    if(typeClient === "cnpj"){
       params.user = clientUser;
       params.password = clientPassword
    }else{
      params.token = token;
    }
    getPanelData(params).then((data) => {
     
      setDataPainel(data);
 
      setIsLoading(false);
    });
  }, []);

  // RETORNO

  return (
    <PanelContext.Provider value={context}>
      <Container sx={{ minWidth: 1100 }}>
        <Stack spacing={3} mb={3}>
          <Stack
            direction="row"
            justifyContent={"space-between"}
            alignItems={"center"}
            spacing={3}
          >
            <Typography
              color="primary"
              component="h1"
              fontWeight={700}
              variant="h4"
            >
              {panelTitle}
            </Typography>
            <img src={clientLogo} style={{ maxWidth: "150px" }}></img>
          </Stack>
          <Stack direction="row" spacing={3}>
            {isLoading ? (
              <Skeleton
                animation="wave"
                sx={{ borderRadius: "40px" }}
                variant="rectangular"
                width="100%"
              >
                <div style={{ paddingTop: "17%" }} />
              </Skeleton>
            ) : (
              <NumberOfMoreDataSaude
                apontamento={false}
                total={dataPainel?.Numbers?.chamados}
              />
            )}
            {/* <GeneratedEconomyCard resume={ resume } /> */}
            {isLoading ? (
              <Skeleton
                animation="wave"
                sx={{ borderRadius: "40px" }}
                variant="rectangular"
                width="100%"
              >
                <div style={{ paddingTop: "17%" }} />
              </Skeleton>
            ) : (
              <NumberOfMoreDataSaude
                apontamento={true}
                apontamentosWpp={dataPainel?.Numbers.apontamentosWpp}
                apontamentosTel={dataPainel?.Numbers.apontamentosLigacao}
                total={dataPainel?.Numbers.apontamentos}
              />
            )}
          </Stack>
          <Stack direction="row" spacing={3}>
            {isLoading ? (
              <Skeleton
                animation="wave"
                sx={{ borderRadius: "40px" }}
                variant="rectangular"
                width="100%"
              >
                <div style={{ paddingTop: "17%" }} />
              </Skeleton>
            ) : (
              <BoxOfDataNumbers
                left={true}
                leftValue={dataPainel?.calcValue.TotalBruto}
                rightValue={dataPainel?.calcValue.TotalDescontos}
              />
            )}

            {isLoading ? (
              <Skeleton
                animation="wave"
                sx={{ borderRadius: "40px" }}
                variant="rectangular"
                width="100%"
              >
                <div style={{ paddingTop: "17%" }} />
              </Skeleton>
            ) : (
              <BoxOfDataNumbers
                left={false}
                leftValue={dataPainel?.calcValue.Desconto}
                rightValue={dataPainel?.calcValue.TicketMedio}
              />
            )}
          </Stack>
        </Stack>
        {isLoading ? (
          <Skeleton
            animation="wave"
            sx={{ borderRadius: "40px" }}
            variant="rectangular"
            width="100%"
          >
            <div style={{ paddingTop: "17%" }} />
          </Skeleton>
        ) : !dataPainel.mostUsed ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              py: 2,
              width: "100%",
            }}
          >
            <Typography component="p" my={3} textAlign="center" variant="h4">
              Nenhum dado encontrado
            </Typography>
          </Box>
        ) : (
          <MostUsedRow mostUsedEstablishments={dataPainel?.mostUsed} />
        )}
        {!isLoading ? (
          <DiscountRanking
            saude={true}
            discountRanking={dataPainel?.recentCpfs.cpfs}
          />
        ) : (
          <Skeleton
            animation="wave"
            sx={{ borderRadius: "40px" }}
            variant="rectangular"
            width="100%"
          >
            <div style={{ paddingTop: "17%" }} />
          </Skeleton>
        )}
      </Container>
    </PanelContext.Provider>
  );
}
